import React from 'react';
import ReactDOM from 'react-dom';
import { Spin } from 'antd';
import PropTypes from 'prop-types';
import { LoadingOutlined } from '@ant-design/icons';

const Icon = <LoadingOutlined style={{ fontSize: 35 }} spin />;

const pageOverlayStyle = {
	position: 'fixed',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	width: '100%',
	height: '100%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	background: 'rgba(224, 224, 224, 0.85)',
	zIndex: 10000,
};

const Loader = (props) => {
	const { align, cover, message, spinning = true } = props;

	if (!spinning) {
		return null;
	}

	const isPageCover = cover === 'page';
	const content = (
		<div
			className={`loading text-${align} cover-${cover}${isPageCover ? '' : ' shadeBackground'}`}
			style={isPageCover ? pageOverlayStyle : undefined}
		>
			<Spin indicator={Icon} tip={message || 'Loading'} size="large" />
		</div>
	);

	// Page overlay must escape layout stacking contexts (e.g. cards on login)
	if (isPageCover && typeof document !== 'undefined') {
		return ReactDOM.createPortal(content, document.body);
	}

	return content;
};

Loader.propTypes = {
	size: PropTypes.string,
	cover: PropTypes.string,
	message: PropTypes.string,
	spinning: PropTypes.bool,
	align: PropTypes.string,
};

Loader.defaultProps = {
	align: 'center',
	cover: 'inline',
	spinning: true,
};

export default Loader;
